import React from "react";
import styles from "./Tabs.module.css";

type Tab = {
  title: string | React.ReactNode;
  content: React.ReactNode;
};

type TabsProps = {
  tabs: Tab[];
  activeTab?: number; 
  onTabChange?: (index: number) => void; 
};

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab: controlledActiveTab,
  onTabChange,
}) => {
  const isControlled = controlledActiveTab !== undefined;
  const [uncontrolledActiveTab, setUncontrolledActiveTab] = React.useState(
    tabs.findIndex((tab) => tab.content) || 0
  );

  const activeTab = isControlled ? controlledActiveTab : uncontrolledActiveTab;

  const handleTabClick = (index: number) => {
    if (!tabs[index].content) return;

    if (isControlled && onTabChange) {
      onTabChange(index);
    } else {
      setUncontrolledActiveTab(index);
    }
  };

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabTitles}>
        <div>
          {tabs.map((tab, index) => (
            <button
              key={index}
              disabled={!tab.content}
              onClick={() => handleTabClick(index)}
              style={{cursor: !tab.content ? 'auto' : 'pointer'}}
              className={`${!tab.content && "font-weight-bold"} ${
                styles.tabTitle
              } ${activeTab === index ? styles.active : ""}`}
            >
              {tab.title}
            </button>
          ))}
        </div>
      </div>
      <div className={styles.tabContent}>{tabs[activeTab]?.content}</div>
    </div>
  );
};

export default Tabs;
